export enum OrderOccupancy {
  VACANT = "vacant",
  OCCUPIED = "occupied",
}
